import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

const LightbulbTip = ({
  description,
  intl
}) => (
  <ul className="list-inline no-bottom-margin">
    <li style={{ maxWidth: '10%' }} className="v-top">
      <img
        alt={ intl.formatMessage({ id: 'inbox.lightbulb_tip.sync', defaultMessage: 'sync info block' }) }
        src="/web-2/assets/images/lightbulb.svg?v=rb"
      />
    </li>
    <li style={{ maxWidth: '90%' }} >{description}</li>
  </ul>
);

LightbulbTip.propTypes = {
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  intl: intlShape
};

exports.LightbulbTip = injectIntl(LightbulbTip);
